import React from 'react';
import PropTypes from 'prop-types';
import {
	makeStyles,
	IconButton
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	root: {
		width: 36,
		height: 36,
		padding: 0,
		// theme.palette.primary.main if we wanted primary color
		border: "1px solid rgba(0, 0, 0, 0.23)", // taken from @material-ui's Button class for outlined buttons

		"& .fa-xs": {
			fontSize: "0.7em"
		}
	},

	label: {
		position: "relative",
		flexDirection: "column"
	},

	text: {
		fontSize: "0.5em",
		position: "absolute",
		top: theme.spacing(3.5)
	},

	primaryContained: {
		backgroundColor: theme.palette.primary.main
	},

	secondaryContained: {
		backgroundColor: theme.palette.secondary.main
	}
}));

const CircledIconButton = React.forwardRef((props, ref) => {
	let classes = styles(),
		{children, color, text, contained, textClassName, labelClassName, ...rest} = props;

	return (
		<IconButton
			{...rest}
			ref={ref}
			color={color}
			classes={{
				label: `${classes.label} ${labelClassName || ""}`,
				root: `${classes.root} ${contained === true ? color === "primary" ? classes.primaryContained : classes.secondaryContained : ""}`
			}}>
			{children}
			{text ? <div className={`${classes.text} ${textClassName}`}>{text}</div> : null}
		</IconButton>
	);
});

CircledIconButton.propTypes = {
	color: PropTypes.string,
	text: PropTypes.string,
	contained: PropTypes.bool,
	labelClassName: PropTypes.string,
	textClassName: PropTypes.string,
	children: PropTypes.any
};

CircledIconButton.displayName = "CircledIconButton";
export default CircledIconButton;
